import type { HandleClientError } from '@sveltejs/kit';

/**
 * Client-side error handler
 * Catches module import failures that occur after deployments
 * and automatically reloads the page to get the new assets
 */
export const handleError: HandleClientError = ({ error, event }) => {
	// Check if it's a module import error (happens when assets are updated)
	const errorMessage = error instanceof Error ? error.message : String(error);

	if (
		errorMessage.includes('Failed to fetch dynamically imported module') ||
		errorMessage.includes('Importing a module script failed') ||
		errorMessage.includes('error loading dynamically imported module')
	) {
		console.warn('🔄 Module import failed (likely due to new deployment). Reloading page...');

		// Reload the page to get the new assets
		// Use location.reload() to ensure we bypass any service worker cache
		if (typeof window !== 'undefined') {
			window.location.reload();
		}

		return {
			message: 'Loading updated version...'
		};
	}

	// Log other errors to console for debugging
	console.error('Client error:', error, 'Event:', event);
	if (error instanceof Error) {
		console.error('Stack:', error.stack);
	}

	// Return a user-friendly message for other errors
	return {
		message: 'Une erreur est survenue. Veuillez réessayer.'
	};
};
